/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";

import { SetStateAction, useEffect, useState } from "react";
import NewSelectInput from "../../../components/NewSelectInput";
import NormalSearch from "../../../components/common/NormalSearch";
import { IconRefresh } from "@tabler/icons-react";
import NewinputField from "../../../components/NewInput";
import { Control, useForm, UseFormClearErrors } from "react-hook-form";
import TextareaField from "../../../components/common/TextareaField";
import { useMerchantAllListData } from "../../../apis/merchantApis";
import {
  useFetchLmClientOrdersData,
  usePickupLocationClientAddressData,
  usePickupLocationtAlltData,
} from "../../../apis/pickupApis";
import ProductTable from "../../DRSManagement/_components/ProductTable";
import { use } from "i18next";
import Pagination from "../../../components/common/Pagination";
import { totalmem } from "os";
import { T, useLanguage } from "../../../context/LanguageContext";

const vehicleTypes = [
  { id: 1, value: "car", text: "Car" },
  { id: 2, value: "van", text: "Van" },
  { id: 3, value: "dokker", text: "DoKker" },
];

const RequestTypeData = [
  { id: 1, value: "Shipment", text: "Request with Shipment" },
  { id: 2, value: "NonShipment", text: "Request without Shipment" },
];

type Props = {
  register: any;
  setValue: any;
  watch: any;
  errors: any;
  clearErrors?: UseFormClearErrors<any>;
  control: Control<any>; // ✅ Add this
  reset?: any;
  // setSelectedOrders: React.Dispatch<React.SetStateAction<string[]>>;
  // selectedOrders: string[];
};

const ReverseProductData = [
  {
    sku: "SKU001",
    itemName: "Sony WH-1000XM5 Headphones",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    weight: "5 kg",
    selected: false,
    image: "/images/products/headphones-orange.png",
  },
  {
    sku: "SKU002",
    itemName: "Sony WH-1000XM5 Headphones",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    weight: "2 kg",
    selected: true,
    image: "/images/products/headphones-green.png",
  },
  {
    sku: "SKU010",
    itemName: "Sony WH-1000XM5 Headphones",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    weight: "3 kg",
    selected: false,
    image: "/images/products/headphones-yellow.png",
  },
  {
    sku: "SKU123",
    itemName: "Sony WH-1000XM5 Headphones",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    weight: "1.5 kg",
    selected: false,
    image: "/images/products/headphones-pink.png",
  },
];

const ReverseItemModal = ({
  register,
  errors,
  setValue,
  watch,
  control,
  reset,
  clearErrors,
}: // selectedOrders,
// setSelectedOrders,
Props) => {
  const { t } = useLanguage();
  const [awbText, setAwbText] = useState("");
  const [searchFor, setSearchFor] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loadOrder, setLoadOrder] = useState(false);

  // const { register, handleSubmit } = useForm();
  const { data: clients } = useMerchantAllListData();
  const { data: pickupLocations } = usePickupLocationtAlltData();
  const { data: clientAddresses } = usePickupLocationClientAddressData(
    watch("clientId") || ""
  );
  const { data: ClientOrders, refetch } = useFetchLmClientOrdersData(
    pageNo,
    limit,
    searchFor,
    watch("clientId") || "",
    loadOrder
  );

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  const onSubmit = (data: any) => {
    console.log(data);
  };

  const [check, setCheck] = useState(false);
  useEffect(() => {
    setValue("requestType", "PICKUP");
  }, []);

  useEffect(() => {
    refetch();
  }, [watch("clientId")]);

  return (
    <div
      // onSubmit={handleSubmit(onSubmit)}
      className="w-full py-4 px-6 space-y-4 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]"
    >
      <div className="h-[calc(100vh-13rem)] overflow-y-auto space-y-4">
        <div className="grid grid-cols-4 gap-4">
          <div className="col-span-full space-y-3 border-[1.5px] border-[#D2D2D2]  rounded-lg">
            <table className="w-full">
              <thead>
                <tr className="border-b border-[#D8D8D8] border-dashed">
                  <th className="text-center px-3 text-sm font-medium text-[#212121]/70">
                    <label className="relative flex items-center ">
                      <input
                        type="checkbox"
                        // disabled={readOnly}
                        {...register("multipleAccessWarehouse")}
                        defaultChecked={setCheck}
                        className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] transition-all 
             bg-white checked:bg-[#FBD037] checked:text-white"
                      />
                      <span className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                        ✓
                      </span>
                    </label>
                  </th>

                  <th className="text-center p-2 text-sm font-medium text-[#212121]/70">
                    #
                  </th>
                  <th className="text-left p-2 text-sm font-medium text-[#212121]/70">
                    <T>SKU</T>
                  </th>

                  <th className="text-left p-2 text-sm font-medium text-[#212121]/70">
                    <T>Item Name</T>
                  </th>
                  <th className="text-left p-2 text-sm font-medium text-[#212121]/70">
                    <T>Actual Qty.</T>
                  </th>
                  <th className="text-left p-2 text-sm font-medium text-[#212121]/70">
                    <T>Return Qty.</T>
                  </th>
                  <th className="text-left p-2 text-sm font-medium text-[#212121]/70">
                    <T>Weight</T>
                  </th>
                  <th className="text-left p-2 text-sm font-medium text-[#212121]/70">
                    <T>Return Reason</T>
                  </th>
                  {/* <th className="text-left p-2 text-sm font-medium text-[#212121]/70">
                    Action
                  </th> */}
                </tr>
              </thead>

              <tbody>
                {ReverseProductData.map((item, i) => (
                  <tr
                    key={i}
                    className="hover:bg-[#FBD037]/20 transition cursor-pointer"
                  >
                    <td className="p-3 text-base text-[#212121] text-center">
                      <label className="relative flex items-center ">
                        <input
                          type="checkbox"
                          // disabled={readOnly}
                          {...register("multipleAccessWarehouse")}
                          defaultChecked={setCheck}
                          className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] transition-all 
             bg-white checked:bg-[#FBD037] checked:text-white"
                        />
                        <span className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                          ✓
                        </span>
                      </label>
                    </td>
                    <td className="p-3 text-base text-[#212121] text-center">
                      {i + 1}
                    </td>

                    <td className="p-3 text-base text-[#212121]">
                      {item?.sku || ""}
                    </td>

                    <td className="p-2 text-base text-[#212121]">
                      <div className="flex items-center space-x-4 w-96">
                        <img
                          src="https://m.media-amazon.com/images/I/71R8VsJ07nL._SX522_.jpg"
                          alt="iphone"
                          className="size-16 rounded-md"
                        />
                        <div>
                          <p className="text-sm font-medium capitalize line-clamp-1">
                            iPhone 17 Pro Max 256 GB: 17.42 cm (6.9″)
                          </p>
                          <p className="text-xs text-[#212121]/70 line-clamp-1">
                            UNIBODY DESIGN. FOR EXCEPTIONAL POWER — Heat-forged
                            aluminium unibody enclosure for the most powerful
                            iPhone ever made.
                          </p>
                        </div>
                      </div>
                    </td>
                    <td className="p-2 text-base text-[#212121]">10 </td>
                    <td className="p-2 text-base text-[#212121]">2 </td>

                    <td className="p-2 text-base text-[#212121]">5 kg</td>

                    <td className="p-2 text-base text-[#212121]">
                      <input
                        placeholder={t("Write reason...")}
                        {...register(`products.${i}.note`, {
                          required: false,
                        })}
                        className="rounded-full px-4 py-1.5 text-sm border border-[#D8D8D8] focus:outline-none w-full"
                      />
                    </td>

                    {/* <td className="p-2 text-base text-[#212121]">
                      <button className="px-4 py-1.5 bg-[#FBD037] rounded-full text-sm font-medium">
                        {" "}
                        Create
                      </button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReverseItemModal;
